import { Routes } from '@angular/router';

export enum AccountEndpoints {
  Summary = 'summary',
  Profile = 'profile',
  Subscription = 'subscription',
  PaymentMethod = 'payment',
  ChangePlan = 'change-plan',
  DownloadApp = 'download-app',
}

export const routes: Routes = [
  {
    path: '',
    redirectTo: AccountEndpoints.Summary,
    pathMatch: 'full',
  },
  {
    path: AccountEndpoints.Summary,
    loadComponent: () =>
      import('./summary/summary.component').then((m) => m.SummaryComponent),
  },
  {
    path: AccountEndpoints.Profile,
    loadComponent: () =>
      import('./profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: AccountEndpoints.Subscription,
    loadComponent: () =>
      import('./subscription/subscription.component').then(
        (m) => m.SubscriptionComponent
      ),
  },
  {
    path: AccountEndpoints.PaymentMethod,
    loadComponent: () =>
      import('./payment-methods/payment-methods.component').then(
        (m) => m.PaymentMethodsComponent
      ),
  },
  {
    path: AccountEndpoints.ChangePlan,
    loadComponent: () =>
      import('./change-plan/change-plan.component').then(
        (m) => m.ChangePlanComponent
      ),
  },
  {
    path: AccountEndpoints.DownloadApp,
    loadComponent: () =>
      import('./download-app/download-app.component').then(
        (m) => m.DownloadAppComponent
      ),
  },
];
